import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography } from 'antd';
import MobileHeader from '../../../components/mobile/Header';
import ButtonFooter from '../../../components/mobile/ButtonFooter'
import { ReactComponent as CoronaSvg } from '../../../assets/icons/corona.svg';
import { ReactComponent as BrainSvg } from '../../../assets/icons/brain.svg';
import { ReactComponent as MaternalSvg } from '../../../assets/icons/maternal.svg';
import { ReactComponent as NutritionSvg } from '../../../assets/icons/nutrition.svg';
import { ReactComponent as HourGlassSvg } from '../../../assets/icons/knowledge-bank/hourglass.svg';

const { Title, Paragraph } = Typography;

const styles = {
  title: {
    color: '#404047',
    fontWeight: '400',
    fontSize: '20px',
    margin: 0
  },
  subtitle: {
    color: '#15A9E1',
    fontSize: 14,
    textAlign: 'center',
    fontWeight: '300'
  },
  itemTitle: {
    fontSize: 14,
    lineHeight: '17px',
    textAlign: 'center',
    fontWeight: '400',
    color: '#404047',
    marginBottom: 0
  },
  box: {
    background: '#FFFFFF',
    border: '1px solid #F4F4F4',
    borderRadius: 5,
    marginRight: 12,
    marginBottom: 12,
    minHeight: 150
  },
  circle: {
    width: 100,
    height: 100,
    backgroundColor: '#E7E7E7',
    borderRadius: '50%',
    margin: '0 auto',
    marginBottom: 15
  },
  boxComingSoon: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    background: "#F2FBFF",
    border: "1px solid #15A9E1",
    boxShadow: "0px 0px 15px rgba(21, 169, 225, 0.25)",
    borderRadius: "5px",
    padding: "40px 26px 60px"
  },
  comingSoonTitle: {
    fontWeight: "500",
    fontSize: "30px",
    lineHeight: "37px",
    textAlign: "center",
    color: "#15A9E1",
    marginTop: 30,
    marginBottom: 25
  },
  comingSoonDesc: {
    fontWeight: "400",
    fontSize: "15px",
    lineHeight: "24px",
    textAlign: "center",
    color: "#8C8C8C",
    marginBottom: 15
  },
  line: {
    width: 33,
    marginLeft: "auto",
    marginRight: "auto",
    border: "2px solid #15A9E1",
    marginBottom: 25
  }
};

const data = [
  {name: 'Covid', icon: <CoronaSvg />, url: '/speak-doctor/covid'},
  {name: 'Mental Health', icon: <BrainSvg />, url: '/speak-doctor/mental-health-questions'},
  {name: 'Maternal & Child', icon: <MaternalSvg />, url: '/speak-doctor/pregnancy'},
  {name: 'Nutrition', icon: <NutritionSvg />, url: '/speak-doctor/nutrition'},
];

function MobileHomeGuestScreen() {
  const { t } = useTranslation(['common', 'welcome']);
  const history = useHistory();

  const createProfile = () => {
    history.push('/sign-up/guest/method');
  }

  const renderAvatar = (item) => {
    return (
      <Col xs={12}>
        <Box paddingY={12} paddingX={18} style={styles.box} onClick={() => history.push(item.url)}>
          {
            item.icon !== null
            ? (
              <Box textAlign="center" style={{ marginBottom: 15 }}>
                {item.icon}
              </Box>
            )
            : (
              <Box style={styles.circle} />
            )
          }
          <Title level={4} style={styles.itemTitle}>
            {item.name}
          </Title>
        </Box>
      </Col>
    )
  }

  return (
    <Box position="relative" height="100%">
      <MobileHeader />
      <Box paddingTop={30} paddingBottom={12} paddingX={20}>
        <Row justify="center" style={{ padding: 0, marginBottom: 25 }}>
          <Col>
            <Title level={4} style={styles.title}>
              {t('welcome:signIn.healthInformation')}
            </Title>
            <p style={styles.subtitle}>
              {t('welcome:login.howHelp')}
            </p>
          </Col>
        </Row>
        {/* <Row>
          {data.map((item) => renderAvatar(item))}
        </Row> */}
        <Box style={styles.boxComingSoon}>
          <HourGlassSvg />
          <Title level={4} style={styles.comingSoonTitle}>
            {t('knowledge-bank:comingSoon.title')}
          </Title>
          <Box style={styles.line} />
          <Paragraph style={styles.comingSoonDesc}>
            {t('knowledge-bank:comingSoon.desc1')}
          </Paragraph>
          <Paragraph>
            {t('knowledge-bank:comingSoon.desc2')}
          </Paragraph>
        </Box>
      </Box>
      {/* <ButtonFooter
        onClick={createProfile}
        title={t('welcome:signIn.createProfile')}
      /> */}
    </Box>
  );
}

export default MobileHomeGuestScreen;
